import Vue from 'vue'
import VueX from 'vuex'

import App from './modules/App.js'
import Slider from './modules/Slider.js'

Vue.use(VueX)

export default new VueX.Store({
  modules: {
    App,
    Slider
  }
})



// WEBPACK FOOTER //
// ./src/store/Store.js